import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Grid, Text } from '@chakra-ui/react';
import { STUB_ORG_RELATIONSHIP } from './stub-organization';
import { findOrganizationRelationship } from './organization-utils';
import { OrganizationForm } from './organization-form';
import TopLevelError from './top-level-error';
import { ORGANIZATION_CONSTANTS } from './organization-constants';
import { OrgDefs } from './org-defs';
import { SubHeader } from './subheader';
import { Select } from '../../components/select/select';
import { styles } from './organization.styles';
import { ServiceLines } from './service-line-selection';
const BASE_ORGANIZATION = {
    toOrganizationId: null,
    fromOrganizationId: null,
    serviceLineId: null
};
const convertAssociationsToMenuItemDto = (associations)=>associations.map((association)=>({
            label: association.organizationName,
            value: association.organizationCode
        }));
const AssociateOrganizationForm = (props)=>{
    const { associations, cancel, doAssociation, edit, errors, openAssociateForm, organization, orgRelationships, orgType, parentOrg, relationship, serviceLines, timezones, title, viewOnly } = props;
    const classes = styles();
    const orgTypeName = orgType && OrgDefs[orgType] ? OrgDefs[orgType].title : 'Unknown';
    const initialState = {
        associateForm: {
            ...BASE_ORGANIZATION
        }
    };
    const [associateOrg, setAssociateOrg] = useState(initialState);
    const [selectedServiceLines, setSelectedServiceLines] = useState([]);
    const [selectedOrgName, setSelectedOrgName] = useState('');
    const _buildRelationshipEdits = (incomingEdits, organization)=>{
        const _organizationRelationshipType = _getOrgRelationshipType();
        const serviceLines = organization.serviceLines ?? [];
        const relationshipEdits = incomingEdits.map((edit)=>{
            const { organizationRelationship } = edit;
            const rel = organizationRelationship;
            const fromOrganizationId = rel.fromOrganizationId ?? (organization.referringOrgId || organization.parentId);
            const toOrganizationId = rel.toOrganizationId ?? organization.id;
            const organizationRelationshipType = rel.organizationRelationshipType || _organizationRelationshipType;
            const searchCandidate = {
                ...organizationRelationship,
                fromOrganizationId,
                toOrganizationId,
                organizationRelationshipType
            };
            const findOrgRel = findOrganizationRelationship(serviceLines, searchCandidate);
            if (findOrgRel !== undefined) {
                return {
                    ...edit,
                    organizationRelationship: {
                        ...findOrgRel
                    }
                };
            }
            const _organizationRelationship = {
                ...STUB_ORG_RELATIONSHIP,
                ...searchCandidate
            };
            return {
                ...edit,
                organizationRelationship: _organizationRelationship
            };
        });
        return relationshipEdits;
    };
    const _getOrgRelationshipType = ()=>{
        return orgType === ORGANIZATION_CONSTANTS.PHYSICIAN_ORGANIZATION ? 'PHYSICIAN_SERVICE' : 'BILLING';
    };
    const handleFormSave = (org, incomingEdits)=>{
        // define the org
        const orgToSave = {
            ...org
        };
        if (!orgToSave.parentTenantId) {
            orgToSave.parentTenantId = parentOrg.tenantId;
            orgToSave.parentId = parentOrg.id;
            orgToSave.organizationType = orgType;
        }
        // create org relationships
        const relationshipEdits = _buildRelationshipEdits(incomingEdits, orgToSave);
        doAssociation(relationshipEdits, orgToSave);
    };
    const handleCancel = ()=>{
        setAssociateOrg((prevState)=>({
                ...prevState,
                associateView: true
            }));
        cancel();
    };
    const handleAssociateSave = ()=>{
        const { associateForm } = associateOrg;
        const orgToSave = {
            ...organization
        };
        let serviceLineEdits = selectedServiceLines ?? [];
        serviceLineEdits = serviceLineEdits.map((sle)=>{
            sle.organizationRelationship.fromOrganizationId = organization.referringOrgId || associateForm.fromOrganizationId;
            sle.organizationRelationship.toOrganizationId = associateForm.toOrganizationId;
            return sle;
        });
        const relationshipEdits = _buildRelationshipEdits(serviceLineEdits, orgToSave);
        doAssociation(relationshipEdits);
    };
    const handleOrgSelection = (event)=>{
        const { target } = event;
        const orgCode = target.value;
        const orgTo = associations.find((assoc)=>assoc.organizationCode === orgCode);
        if (!orgTo) {
            console.warn(`no org handleOrgSelection`, associations, target, orgCode);
        } else {
            setAssociateOrg((prevState)=>({
                    ...prevState,
                    associateForm: {
                        ...prevState.associateForm,
                        toOrganizationId: orgTo.id,
                        fromOrganizationId: parentOrg.id
                    }
                }));
            setSelectedOrgName(orgTo?.displayName ?? orgTo?.organizationName);
        }
    };
    const handleServiceLinesSelection = (edits)=>{
        if (edits) setSelectedServiceLines(edits);
    };
    return /*#__PURE__*/ _jsx(Box, {
        children: openAssociateForm ? /*#__PURE__*/ _jsxs(Grid, {
            children: [
                /*#__PURE__*/ _jsx(SubHeader, {
                    actionName: 'Submit',
                    linkButtonName: 'Cancel',
                    title: title,
                    onLinkButtonClick: handleCancel,
                    onActionClick: handleAssociateSave
                }),
                /*#__PURE__*/ _jsxs(Grid, {
                    sx: classes.associationGrid,
                    children: [
                        /*#__PURE__*/ _jsxs(Grid, {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            sx: classes.input,
                            rowGap: 3,
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    sx: classes.label,
                                    children: `Choose Existing ${orgTypeName}`
                                }),
                                /*#__PURE__*/ _jsx(Select, {
                                    items: convertAssociationsToMenuItemDto(associations),
                                    placeholder: 'Choose...',
                                    onChange: handleOrgSelection,
                                    value: selectedOrgName,
                                    name: "association"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ServiceLines, {
                            orgRelationships: orgRelationships,
                            serviceLines: serviceLines,
                            relationship: relationship,
                            onChange: handleServiceLinesSelection
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(TopLevelError, {
                    errors: errors && errors.errors
                }),
                /*#__PURE__*/ _jsx(OrganizationForm, {
                    orgRelationships: orgRelationships,
                    relationship: relationship,
                    serviceLines: serviceLines,
                    errors: errors,
                    doSave: handleFormSave,
                    cancel: handleCancel,
                    organization: organization,
                    orgType: orgType,
                    viewOnly: viewOnly,
                    edit: edit,
                    timezones: timezones,
                    title: title,
                    showServiceLines: true
                })
            ]
        })
    });
};
AssociateOrganizationForm.displayName = 'AssociateOrganizationForm';
export { AssociateOrganizationForm };
